// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 3454 ? "0959f4a0" : chunkId) + "." + {"400":"d9e8e746efc57b6d","1034":"066a0b95d37f223e","2942":"a03465d60902f1cd","3454":"0492abf1a60a2d14","8882":"a17c21ad71924265"}[chunkId] + ".js";
};